const INITIAL_STATE ={
    nome : '',
    email : '',
    emailValidate : '',
    senha : '',
    senhaValidate : '',
    logotipo : null,
    categoria : '',
    rua : '',
    cidade : '',
    cep : '',
    cnpj: '',
    cnpjValidate: '',
    fone : '',
    face : '',
    site : '',
    cadastroState : ''
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case 'NOME':
            return { ...state, nome: action.payload }
        case 'EMAIL':
            return { ...state, email: action.payload }
        case 'EMAIL_VALIDATE':
            return { ...state, emailValidate: action.payload }
        case 'SENHA':
            return { ...state, senha: action.payload }
        case 'SENHA_VALIDATE':
            return { ...state, senhaValidate: action.payload }
        case 'LOGO':
            return { ...state, logotipo: action.payload }
        case 'CAT':
            return { ...state, categoria: action.payload }
        case 'RUA':
            return { ...state, rua: action.payload }
        case 'CIDADE':
            return { ...state, cidade: action.payload }
        case 'CEP':
            return { ...state, cep: action.payload }
        case 'CNPJ':
            return { ...state, cnpj: action.payload }
        case 'CNPJ_VALIDATE':
            return { ...state, cnpjValidate: action.payload }
        case 'FONE':
            return { ...state, fone: action.payload }
        case 'FACE':
            return { ...state, face: action.payload }
        case 'SITE':
            return { ...state, site: action.payload }
        case 'CADASTRO_STATE':
            return { ...state, cadastroState: action.payload }
        default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/cadastro.js